import React from 'react';
import PropTypes from 'prop-types';

import Head from 'nordic/head';
import Error404 from '@andes/technical-error/build/presets/Error404';

import {
  APPLICATION_TITLE_ES,
  APPLICATION_TITLE_PT,
} from '../../../constants/appConstants';
import BlogUi from '../../ui-components/blog';
import { getBlogData } from '../../../services/blogApiService';

const Blog = (props) => {
  const { device, blogData, jsDisabled, supportWebP, notFoundError } = props;

  if (notFoundError) {
    return <Error404 />;
  }

  return (
    <>
      <Head>
        <meta name="description" content={blogData.description} />
      </Head>
      <BlogUi
        device={device}
        blogData={blogData}
        jsDisabled={jsDisabled}
        supportWebP={supportWebP}
      />
    </>
  );
};

export const getServerSideProps = async (req, res) => {
  const siteId = req?.platform?.siteId;
  const device = req.device.type;

  const { device_noscript: deviceNoScript } = req.cookies;
  const jsDisabled = Boolean(deviceNoScript);
  const supportWebP = req.browser.support.webp;

  const { tag, page } = req.params;
  const tagFormatted = tag.replaceAll(/-/gi, ' ');

  const titleTemplate =
    siteId === 'MLB' ? APPLICATION_TITLE_PT : APPLICATION_TITLE_ES;
  const finalTitle = titleTemplate.replace('{tag}', tagFormatted);

  const settings = {
    title: finalTitle,
  };

  if (Number.isNaN(page)) {
    res.status(404);

    return {
      props: {
        device,
        jsDisabled,
        supportWebP,
        notFoundError: true,
      },
      settings,
    };
  }

  const pageNumber = parseInt(page, 10);

  if (pageNumber === 0) {
    res.redirect(301, `/blog/${tag}/1`);

    /* eslint-disable-next-line consistent-return */
    return;
  }

  const requestData = {
    siteId,
    tag: tagFormatted,
    pageNumber,
  };
  const response = await getBlogData(req, requestData);

  if (!response.isValid || response.blogs.length === 0) {
    res.status(404);

    return {
      props: {
        device,
        jsDisabled,
        supportWebP,
        notFoundError: true,
      },
      settings,
    };
  }

  return {
    props: {
      device,
      jsDisabled,
      supportWebP,
      blogData: response,
      notFoundError: false,
    },
    settings,
  };
};

export const setPageSettings = ({ settings }) => ({
  ...settings,
});

Blog.propTypes = {
  device: PropTypes.string.isRequired,
  jsDisabled: PropTypes.bool.isRequired,
  supportWebP: PropTypes.bool.isRequired,
  notFoundError: PropTypes.bool.isRequired,
  blogData: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    page: PropTypes.number.isRequired,
    total_pages: PropTypes.number.isRequired,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        image: PropTypes.shape({
          url: PropTypes.string.isRequired,
          alt: PropTypes.string.isRequired,
        }).isRequired,
        description: PropTypes.string.isRequired,
        tags: PropTypes.arrayOf(PropTypes.string),
        tags_metadata: PropTypes.arrayOf(
          PropTypes.shape({
            url: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
          }),
        ),
      }),
    ),
  }).isRequired,
};

export default Blog;
